import React from 'react';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { AbstractButton } from '../../../base/toolbox/components';
/**
 * Component that renders a custom toolbox button.
 *
 * @returns {Component}
 */
class CustomOptionButton extends AbstractButton {
    constructor() {
        super(...arguments);
        // @ts-ignore
        this.iconSrc = this.props.icon;
        // @ts-ignore
        this.id = this.props.id;
        // @ts-ignore
        this.text = this.props.text;
        this.accessibilityLabel = this.text;
        /**
         * Custom icon component.
         *
         * @param {any} props - Icon's props.
         * @returns {img}
         */
        this.icon = (props) => (React.createElement("img", { src: this.iconSrc, ...props }));
        this.label = this.text;
        this.tooltip = this.text;
    }
}
export default CustomOptionButton;
